import * as React from "react";
import BsHelmet from "../components/shared/BsHelmet";

import "../css/global.css";
import "../css/helping-class.css";

import {graphql} from "gatsby";
import {useTranslation} from "gatsby-plugin-react-i18next";
import Hero from "../page-components-new/home/hero";
import CustomerLogos from "../page-components-new/home/customers-logo";
import PowerfulFeatures from "../page-components-new/home/powerful-features";
import Setup from "../page-components-new/home/setup-component";
import CompatibleWithPlateform from "../page-components-new/home/compatible-with";
import PricingPlan from "../page-components-new/home/pricing-plan";
import FAQ from "../page-components-new/home/faq";
import CTA from "../page-components-new/home/cta";
import Footer from "../page-components-new/home/footer";
import Examples from "../page-components-new/home/examples";
import Header from "../page-components-new/home/header";
import CaseStudies from "../page-components-new/home/case-studies";
import IndustryEntries from "../page-components-new/home/industry-entries";
import Security from "../page-components-new/home/security";
import EmailCopilotSection from "../page-components-new/home/email-copilot-section";
import SectionRule from "../components/shared/section-rule";

const IndexPage = ({data}) => {
    const {t} = useTranslation();

    const softwareApplicationSchema = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "ChatLab",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web-based",
        "offers": {
            "@type": "AggregateOffer",
            "lowPrice": "18",
            "highPrice": "360",
            "priceCurrency": "USD",
            "priceValidUntil": "2026-12-31"
        },
        "description": "No-code AI agent platform for 24/7 customer support across four channels: chatbot, email, voice and WhatsApp.",
        "featureList": [
            "AI-powered customer support across four channels (chatbot, email, voice, WhatsApp)",
            "Multi-language support (80+ languages)",
            "Voice conversation models (OpenAI GPT Realtime, Google Gemini Live, ElevenLabs)",
            "Phone number integration via SIP for inbound voice calls",
            "Bot Talk API for programmatic access (REST + SSE)",
            "Management API and Frontend Widget API",
            "E-commerce integrations (Shopify, WooCommerce, PrestaShop, and more)",
            "Hotel and travel integrations (Beds24, Hotres, IdoBooking, KWHotel, Mews, NFHotel)",
            "Live chat escalation",
            "Lead collection",
            "Analytics and AI conversation insights",
            "Email Copilot with AI-powered replies"
        ]
    };

    return (
        <>
            <BsHelmet
                title={t("ChatLab - AI Agent Platform: Chatbot, Email, Voice & Phone for 24/7 Customer Support")}
                desc={t("ChatLab is a no-code AI agent platform for 24/7 customer support across four channels - chatbot, email, voice and WhatsApp. Train on your website, documents and FAQs without code. 80+ languages, voice models from $19/mo add-on, phone slots from $29/mo. Plans from $18/month.")}
                isHomePage={true}
            >
                <script type="application/ld+json">
                    {JSON.stringify(softwareApplicationSchema)}
                </script>
            </BsHelmet>
            <div id="home" className="relative flex flex-col w-full max-w-8xl mx-auto">
                <Header/>
                <main className="overflow-hidden flex flex-col gap-14 sm:gap-20 lg:gap-24 pt-8 sm:pt-12">
                    <Hero/>
                    <CustomerLogos/>
                    <SectionRule/>
                    <Setup/>
                    <SectionRule/>
                    <PowerfulFeatures/>
                    <SectionRule/>
                    <EmailCopilotSection/>
                    <SectionRule/>
                    <Examples/>
                    <SectionRule/>
                    <CompatibleWithPlateform/>
                    <SectionRule/>
                    <IndustryEntries/>
                    <SectionRule/>
                    <div id="case-studies"><CaseStudies/></div>
                    <SectionRule/>
                    <PricingPlan/>
                    <SectionRule/>
                    <FAQ/>
                    <SectionRule/>
                    <Security/>
                    <SectionRule/>
                    <CTA/>
                </main>
                <Footer/>
            </div>
        </>
    );
};

export default IndexPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
